import clsx from 'clsx';
import React, {
  ReactNode,
} from 'react';

export type Prop = {
  id: string;
  containerClassName?: string;
  className?: string;
  label?: string;
  actions?: ReactNode;
  required?: boolean;
};

function LabelWithActions({
  id,
  containerClassName,
  className,
  actions,
  label,
  required,
}: Prop) {
  const containerClasses = clsx('flex items-center justify-between', containerClassName);
  const classes = clsx('font-semibold relative pr-1.5', className);

  return (
    <div className={containerClasses}>
      <label
        htmlFor={id}
        className={classes}
      >
        {label}
        {required && <sup className="absolute right-0 !text-lg text-red-500 font-semibold -top-2">*</sup>}
      </label>
      {actions}
    </div>
  );
}

export default LabelWithActions;
